import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as Api from '@/app/state-serialization/api'
import { QuestionAttemptsTrackingState, QuestionAttemptTrackingState } from '../common'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';

@injectable()
export class QuestionAttemptsStateProtobufSerializer implements
Api.StateSerializationPlugin<QuestionAttemptsTrackingState[]> {

  key = { id: 7, name: { ns: 'suspend-data', name: 'questionAttempts' }, format: 'protobuf' }

  serialize(data: QuestionAttemptsTrackingState[]): Result<Uint8Array, Api.SerializerError> {
    const questions = data.map(question => {
      return new QuestionAttemptsProtoMessage({
        id: question.id,
        attempts:  question.attempts.map(x => this.serializeAttempt(x))
      })
    })

    const message = new QuestionAttemptsCollectionProtoMessage({
      questions: questions
    })

    return ProtobufSerializer
      .serialize<QuestionAttemptsCollectionProtoMessage>(
        message, QuestionAttemptsCollectionProtoMessage)
  }

  private serializeAttempt(attempt: QuestionAttemptTrackingState) {
    return new QuestionAttemptProtoMessage({
      thinkingTimeSeconds: attempt.thinkingTimeSeconds,
      achievedScore: attempt.achievedScore
    })
  }

  deserialize(content: Uint8Array): Result<QuestionAttemptsTrackingState[], Api.DeserializerError> {
    const messageResult = ProtobufSerializer
      .deserialize<QuestionAttemptsCollectionProtoMessage>(
        content, QuestionAttemptsCollectionProtoMessage)

    if (!messageResult.success) {
      return messageResult
    }

    const message = messageResult.value
    const questions = message.questions.map(question => ({
      id: question.id,
      attempts: question.attempts.map(x => this.deserializeAttempt(x))
    }))

    return ok(questions)
  }

  private deserializeAttempt(
    attempt: QuestionAttemptProtoMessage): QuestionAttemptTrackingState {
    return {
      thinkingTimeSeconds: attempt.thinkingTimeSeconds,
      achievedScore: attempt.achievedScore
    }
  }
  
}

@Type.d('QuestionAttemptProtoMessage')
class QuestionAttemptProtoMessage extends Message<QuestionAttemptProtoMessage> {

  @Field.d(1, 'uint32', "optional", 0)
  thinkingTimeSeconds: number

  @Field.d(2, 'float', "optional", 0)
  achievedScore: number 
}

@Type.d('QuestionAttemptsProtoMessage')
class QuestionAttemptsProtoMessage extends Message<QuestionAttemptsProtoMessage> {

  @Field.d(1, 'string', "optional", '')
  id: string

  @Field.d(2, QuestionAttemptProtoMessage, 'repeated')
  attempts: QuestionAttemptProtoMessage[]
}

@Type.d('QuestionAttemptsCollectionProtoMessage')
class QuestionAttemptsCollectionProtoMessage extends Message<QuestionAttemptsCollectionProtoMessage> {

  @Field.d(1, 'uint32', 'optional', 1)
  public schemaVersion: number

  @Field.d(2, QuestionAttemptsProtoMessage, 'repeated')
  public questions: QuestionAttemptsProtoMessage[]

}



